<footer
  macmsColor
  [mc_isInverted]="settings.isNavInverted"
  [mc_wantedPrimary]="settings.primaryColor"
  [ngClass]="{limited: settings.isWrapperLimited}">
  <div class="navigation"

  >
    <macms-footer-nav *ngIf="data" [data]="data" [settings]="settingsForNavigation"></macms-footer-nav>
    <macms-kontakt
      [settings]="settingsForKontakt"></macms-kontakt>

    <div class="social">

        <a title="Weby obcí" class="social-icon" target="_blank" [href]="'http://webyobci.cz/'">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 172.89 57.88" [style.height]="'30px'" [attr.fill]="obecSettings.primary_color">
  <defs/>
  <path d="M144 0H52.77a38.3 38.3 0 018.92 25.36l-3.95.56-11.29 1.62L15.38 32l-2.14-14.89 30.19-4.32a23.31 23.31 0 100 23.55l14.88 3.93a38.49 38.49 0 01-16 17.61H144A28.93 28.93 0 00172.89 29 28.94 28.94 0 00144 0zM88.81 35.45a5 5 0 004.73-2.9h6c-1.29 4.89-5.34 7.88-10.71 7.88-6.66 0-11.35-4.72-11.35-11.48s4.69-11.51 11.35-11.51c5.37 0 9.42 3 10.71 7.91h-6a5 5 0 00-4.73-2.89c-3.37 0-5.69 2.51-5.69 6.49s2.32 6.5 5.69 6.5zm39.72 4.82H123V26.73l-5 13.54h-4.44l-5.1-13.57v13.57H103V17.7h6.5l6.33 15.63 6.3-15.63h6.47zm12.12.23c-4.86 0-8.65-2.41-8.81-7h5.85a2.6 2.6 0 002.58 2.58h.22c1.61 0 2.63-.8 2.63-2.12 0-4.18-11.28-1.93-11.22-9.94 0-4.27 3.51-6.65 8.23-6.65 4.92 0 8.23 2.44 8.46 6.75h-6a2.42 2.42 0 00-2.49-2.35h-.1a2 2 0 00-2.29 1.65 2.81 2.81 0 000 .41c0 3.92 11.16 2.15 11.16 9.71.01 3.81-2.95 6.96-8.22 6.96z" class="a"/>
</svg>
        </a>

      <a class="social-icon" href="http://www.czechpoint.cz">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 506.5 226.4" [style.height]="'30px'" [attr.fill]="obecSettings.primary_color"
             xml:space="preserve">
          <g>
	<polygon class="st0" points="506.5,113.7 506.5,113.7 506.5,113.6 	"/>
            <polygon class="st0" points="-0.2,113.7 -0.2,113.7 -0.2,113.6 	"/>
</g>
          <g>
	<path class="st1"
        d="M286.3,100.3c-1.4-0.9-2.6-1.2-4.4-1.2h-9v13.2h9.2c4.6,0,6.9-3.4,6.9-6.6C289,103,287.9,101.3,286.3,100.3z"
  />
            <path class="st1" d="M321.6,99.1c-2.9,0-5.1,1.4-6.3,3c-1.6,2.1-2.1,3.2-2.1,11.6c0,8.4,0.5,9.5,2.1,11.6c1.3,1.6,3.4,3,6.3,3
		c2.9,0,5.1-1.4,6.3-3c1.6-2.1,2.1-3.2,2.1-11.6c0-8.4-0.5-9.6-2.1-11.6C326.6,100.5,324.5,99.1,321.6,99.1z"/>
            <path class="st1" d="M393.7,0.9c-29.8,0-54.8,13.2-74.9,30.3c0,0-6.7,5.8-7.2,6.3c-8.3,8.1-29.7,24.8-58.4,24.9h0
		c-28.7-0.1-50.1-16.8-58.4-24.9c-0.5-0.5-7.2-6.3-7.2-6.3C167.4,14,142.4,0.9,112.6,0.9C50.3,0.9-0.2,51.4-0.2,113.7
		c0,62.3,50.5,112.8,112.8,112.8c29.8,0,54.8-13.1,74.9-30.3c0,0,6.7-5.8,7.2-6.3c8.3-8.1,29.7-24.8,58.4-24.9h0
		c28.7,0.1,50.1,16.8,58.4,24.9c0.5,0.5,7.2,6.3,7.2,6.3c20.1,17.2,45.1,30.3,74.9,30.3c62.3,0,112.8-50.5,112.8-112.8
		C506.5,51.4,456,0.9,393.7,0.9z M73.1,125.4c1.3,1.6,3.4,3,6.3,3c3.5,0,6.1-1.9,7.8-5.6h6.6c-1.6,7.6-7.4,11.8-14.4,11.8
		c-6.4,0-10.9-3.8-12.8-7.4c-1.3-2.4-1.8-3.6-1.8-13.5c0-9.8,0.5-11,1.8-13.5c2-3.6,6.4-7.4,12.8-7.4c7.8,0,13.1,5.5,14.4,12.1h-6.6
		c-1-3.2-3.9-5.9-7.8-5.9c-2.9,0-5.1,1.4-6.3,3c-1.6,2.1-2.1,3.2-2.1,11.6C71,122.2,71.5,123.3,73.1,125.4z M129.3,97.9l-18.6,30.4
		h18.6v5.9h-26.2v-5.2l18.6-30.3h-17.8v-5.5h25.4V97.9z M169.2,99.1h-20v11.7h17v5.5h-17v12h20v5.9H143v-41h26.2V99.1z M189.4,125.4
		c1.3,1.6,3.4,3,6.3,3c3.4,0,6.1-1.9,7.8-5.6h6.6c-1.6,7.6-7.4,11.8-14.4,11.8c-6.4,0-10.9-3.8-12.8-7.4c-1.3-2.4-1.8-3.6-1.8-13.5
		c0-9.8,0.5-11,1.8-13.5c1.9-3.6,6.4-7.4,12.8-7.4c7.8,0,13.1,5.5,14.4,12.1h-6.6c-1-3.2-3.9-5.9-7.8-5.9c-2.9,0-5.1,1.4-6.3,3
		c-1.6,2.1-2.1,3.2-2.1,11.6C187.3,122.2,187.8,123.3,189.4,125.4z M250.6,134.2h-6.2v-17.9h-16.2v17.9h-6.2v-41h6.2v17.6h16.2V93.3
		h6.2V134.2z M282.4,118.2h-9.4v16h-6.2v-41h14.8c3.2,0,6,0.4,9.2,2.9c2.5,1.9,4.4,5.4,4.4,9.8C295.2,111.7,290.8,118.2,282.4,118.2
		z M334.4,127.2c-2,3.6-6.4,7.4-12.8,7.4c-6.4,0-10.9-3.8-12.8-7.4c-1.3-2.4-1.8-3.6-1.8-13.5c0-9.8,0.5-11,1.8-13.5
		c1.9-3.6,6.4-7.4,12.8-7.4c6.4,0,10.9,3.8,12.8,7.4c1.3,2.4,1.8,3.6,1.8,13.5C336.2,123.6,335.7,124.8,334.4,127.2z M357.1,134.2
		h-6.2v-41h6.2V134.2z M404,134.2h-5.9l-18.5-29.1h-0.1v29.1h-6.2v-41h5.9l18.5,29.1h0.1V93.3h6.2V134.2z M444.5,98.8h-11.2v35.4
		H427V98.8h-11.2v-5.5h28.7V98.8z"/>
</g>
</svg>
      </a>
      <ng-container *ngIf="obecSettings.social_settings && obecSettings.social_settings.rajce_url">
        <a title="rajče.idnes.cz" class="social-icon" target="_blank" [href]="obecSettings.social_settings.rajce_url">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 365.33 370.31" [style.height]="'30px'" [attr.fill]="obecSettings.primary_color"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M167.47,370.3c-35.81.39-73.11-13.5-105.07-40.2-34.67-29-55.73-66.14-61-111.55-4-33.9.71-66.5,15.76-97.17Q42.27,70.11,92.89,43c20.57-11,42.53-17.25,65.65-19.53,5-.49,17.87-1.06,17.87-1.06l7.22,22s-1.37,0-5.34-.17a144.48,144.48,0,0,0-43.51,4.92C102.22,58,75.62,76,54.48,102.16c-18.6,23-29.92,49.25-32.7,78.7-3.22,34.12,3.51,66.2,21.78,95.61,10.78,17.34,24.13,32.26,40.76,44,21.7,15.37,45.56,25.24,72.33,27.88,28.16,2.78,55.21-.88,80.86-12.87a151.41,151.41,0,0,0,55.92-44.18,153,153,0,0,0,31.66-74,145.77,145.77,0,0,0-3.07-57c-1.51-5.93-1.37-5.5-1.37-5.5l22.41,3.29s.48,2.46,1.26,6.56c6.36,33.45,3.4,66.08-9.56,97.51-15.79,38.32-42.11,67.33-78.64,87.26C230.37,363.51,203,370.31,167.47,370.3Z"/><path class="cls-1" d="M352.5,146.51a153.39,153.39,0,0,1-71.38-28.64c2.35,11.75,9.51,18.49,16.69,25.87-2.05-.66-4.13-1.22-6.13-2-15.55-6-29.26-14.39-37.86-29.42-2.44-4.27-4.25-4.3-7.43-.33s-5.91,7.91-9.38,12.59c-2.57-9-4.23-17.33-2.53-26,1.15-5.85,1.06-5.73-4.68-6.42-17.53-2.1-32-9.7-42.64-24A13.17,13.17,0,0,1,186,65a14.17,14.17,0,0,1,3.26-.69c5.64.2,11.28.68,16.92.71,1.67,0,3.35-1.16,5-1.78a28.62,28.62,0,0,0-2.6-4.4c-8.17-9.52-12.28-20.91-15-32.86-1.54-6.91-2.55-21.32-2.11-21.48,2.62,3.68,5.33,7.31,7.83,11.06,6.58,9.87,15.48,17.35,25,24.16,3.7,2.66,4.29,2.22,5.44-2.36q4-16,8.19-31.92c.5-1.89,3-5.45,3.51-5.43,0,2.31,0,4.62,0,6.92-.13,15.4.84,30.58,7,45,5.36,12.5,8.07,13.55,19.26,6.06a132.81,132.81,0,0,0,27.8-25.6c.61-.72,2.44-1.88,3-1.5-1,4.1-1.45,8.43-3.08,12.26q-6.12,14.46-13.16,28.54c-2.76,5.52-3,6.51,3.14,7.85,9.23,2,18.61,4,28,4.44,15.3.73,30.65.2,46,.19,1.78,0,5.71,1,5.89,1.42-4.39,2.73-8.68,5.62-13.18,8.17a113.69,113.69,0,0,1-33,12.57c-4.75,1-5.35,2.75-1.65,6.24,10,9.47,20.31,18.69,30.53,28C349.69,142.09,352.79,145.93,352.5,146.51Z"/></g></g></svg>
        </a>
      </ng-container>
      <ng-container *ngIf="obecSettings.social_settings && obecSettings.social_settings.facebook_url">
        <a title="facebook" class="social-icon" target="_blank" [href]="obecSettings.social_settings.facebook_url">
          <fa-icon [icon]="['fab','facebook']"></fa-icon>
        </a>
      </ng-container>
      <ng-container *ngIf="obecSettings.social_settings && obecSettings.social_settings.twitter_url">
        <a title="twitter" class="social-icon" target="_blank" [href]="obecSettings.social_settings.twitter_url">
          <fa-icon [style.color]="obecSettings.primary_color" [icon]="['fab','twitter']"></fa-icon>
        </a>
      </ng-container>
      <ng-container *ngIf="obecSettings.social_settings && obecSettings.social_settings.instagram_url">
        <a title="instagram" class="social-icon" target="_blank" [href]="obecSettings.social_settings.instagram_url">
          <fa-icon [icon]="['fab','instagram']"></fa-icon>
        </a>
      </ng-container>
      <ng-container *ngIf="obecSettings.social_settings && obecSettings.social_settings.youtube_url">
        <a title="youtube" class="social-icon" target="_blank" [href]="obecSettings.social_settings.youtube_url">
          <fa-icon [icon]="['fab','youtube']"></fa-icon>
        </a>
      </ng-container>
    </div>


  </div>
  <div class="copyright" macmsColor
       [mc_wantedPrimary]="secondaryColor"
       [mc_useTransparent]="false"
       [mc_otherColors]="[settings.accentColor,settings.primaryColor,settings.secondaryColor,'#dbdbdb']"
       [mc_isInverted]="settings.isCopyrightInverted"
       [paddingDefinition]="settings.copyrightPadding"
  >
    <div class="copyrightwrap">
      <macms-kontakt
        [settings]="{
  showCopyright: true,
  showHeading: false,
  isConcatenated: true
}"></macms-kontakt>

      <div class="loginBox">
        <a macmsColor
          [mc_wantedPrimary]="settings.primaryColor"
          [mc_otherColors]="[settings.accentColor,settings.primaryColor,settings.secondaryColor,'#dbdbdb']"
          [style.fontFamily]="obecSettings.title_font"
          href="http://webyobci.cz/" target="_blank">Přihlásit se
          <fa-icon [icon]="['fas','user-lock']"></fa-icon>
        </a>
      </div>
    </div>

  </div>
</footer>
